import { useMemo } from 'react';
import { formatDate, daysUntil } from '../lib/dates.js';
import './DeadlineBanner.css';

export default function DeadlineBanner({ entries, max = 2 }) {
  const upcoming = useMemo(() => {
    return entries
      .filter(e => e.date && daysUntil(e.date) >= 0)
      .sort((a, b) => new Date(a.date + 'T12:00:00') - new Date(b.date + 'T12:00:00'))
      .slice(0, max);
  }, [entries, max]);

  if (upcoming.length === 0) return null;

  return (
    <div className="deadline-banner" role="region" aria-label="Coming up">
      <p className="deadline-banner-eyebrow">Coming up</p>
      <ul className="deadline-banner-list">
        {upcoming.map(entry => {
          const days = daysUntil(entry.date);
          let daysLabel;
          if (days === 0) daysLabel = 'Today';
          else if (days === 1) daysLabel = 'Tomorrow';
          else daysLabel = `${days} days`;

          return (
            <li
              key={entry.id}
              className={`deadline-banner-item deadline-banner-item--${entry.priority}`}
            >
              <span className="deadline-banner-countdown" aria-label={`${daysLabel} from now`}>
                {daysLabel}
              </span>
              <span className="deadline-banner-body">
                <span className="deadline-banner-title">{entry.title}</span>
                <span className="deadline-banner-date">{formatDate(entry.date, 'medium')}</span>
              </span>
              {entry.actionRequired && (
                <span className="deadline-banner-badge" aria-label="Action required">
                  Action required
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
